import { Module } from 'vuex'

import { GetSourceCodeByJudgeIdUseCase } from '@/application/sourceCode/getSourceCodeByJudgeIdUseCase'
import { SourceCodeRepository } from '@/domain/repositories/sourceCode/sourceCodeRepository'

interface HistorySourceCodeState {
  historySourceCodeList: { [judgeId: number]: string }
  isLoading: boolean
  error: Error | null
}

export const historySourceCodeModule = (
  sourceCodeRepository: SourceCodeRepository
): Module<HistorySourceCodeState, any> => {
  const getSourceCodeByJudgeIdUseCase = new GetSourceCodeByJudgeIdUseCase(sourceCodeRepository)

  return {
    namespaced: true,
    state: {
      historySourceCodeList: {},
      isLoading: false,
      error: null
    },
    mutations: {
      setHistorySourceCodeList(state, { list }: { list: { [judgeId: number]: string } }) {
        state.historySourceCodeList = list
      },
      setHistorySourceCodeListItem(state, { judgeId, item }: { judgeId: number; item: string }) {
        state.historySourceCodeList[judgeId] = item
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchHistorySourceCodeList({ state, commit }, { judgeId }: { judgeId: number }) {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          const item = await getSourceCodeByJudgeIdUseCase.getSourceCodeByJudgeId(judgeId)
          commit('setHistorySourceCodeListItem', { judgeId, item })
        } catch (error) {
          commit('setError', error)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      historySourceCodeList: state => state.historySourceCodeList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
